export const GAME_PAGE_MAIN_ID = 'game-page-main';

export const GAME_PAGE_WRAPPER_ID = 'game-page-wrapper';

export const GAME_PAGE_LOGO_HEIGHT = 80;
export const GAME_PAGE_LOGO_HEIGHT_ASPECT = GAME_PAGE_LOGO_HEIGHT / 1024;

export const GAME_PAGE_LOGO_WIDTH = 180;
export const GAME_PAGE_LOGO_WIDTH_ASPECT = GAME_PAGE_LOGO_WIDTH / 1920;
